import { memo, ReactNode } from 'react';
import { Alert, Button } from '@amzn/awsui-components-core';

interface ScanFailedAlertProps {
  /** Severity: an author who can retry sees an error, a reviewer who cannot sees a warning. */
  readonly type?: 'error' | 'warning';
  /** When provided, renders a Rescan action that starts another scan. */
  readonly onRescan?: () => void;
  readonly isRescanDisabled?: boolean;
  readonly children: ReactNode;
}

/**
 * Shown when a quality check scan concluded in failure. A failed scan produces
 * no findings, so the findings table alone reads as "no issues"; this makes the
 * failure explicit.
 */
export const ScanFailedAlert = memo(function ScanFailedAlert({
  type = 'error',
  onRescan,
  isRescanDisabled,
  children,
}: ScanFailedAlertProps) {
  return (
    <Alert
      type={type}
      header="Quality check failed"
      action={
        onRescan && (
          <Button variant="inline-link" onClick={onRescan} disabled={isRescanDisabled}>
            Rescan
          </Button>
        )
      }
    >
      {children}
    </Alert>
  );
});
